import React, { Component } from 'react';
import RenderInBody from 'components/RenderInBody';
import styled from 'styled-components';

const OptionContainer = styled.div`
  padding: 10px;
  &:hover {
    background: rgba(79, 195, 247, 1);
    color: rgba(255, 255, 255, 1);
  }
`;

const Container = styled.div`
  z-index: 1000000;
  position: absolute;
  min-width: 119px;
  max-width: 119px;
  top: ${(props) => props.y}px;
  left: ${(props) => props.x}px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(211, 211, 211, 0.5);
  padding-top: 5px;
  padding-bottom: 5px;
  &:hover {
    cursor: pointer;
  }
`;

export default class ContextOptions extends Component {
  constructor(props) {
    super(props);
    this.createOptions = this.createOptions.bind(this);
    this.getOptionButton = this.getOptionButton.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.close();
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  getOptionButton(option, count) {
    return (
      <OptionContainer
        onClick={option.onClick.bind(null, this.props.value, this.props.close, this.props.rowIdx)}
        key={count + 'ContextOption'}
      >
        {option.label}
      </OptionContainer>
    );
  }

  createOptions() {
    let menuOptions = [];
    let count = 0;
    for (let option of this.props.options) {
      menuOptions.push(this.getOptionButton(option, count));
      count++;
    }
    return menuOptions;
  }

  render() {
    if (this.props.shouldRender) {
      let menuOptions = this.createOptions();
      return (
        <div>
          <RenderInBody>
            <Container ref={this.setWrapperRef} x={this.props.x} y={this.props.y}>
              {menuOptions}
            </Container>
          </RenderInBody>
          <i className="icon">menu</i>
        </div>
      );
    }
    return <i className="icon">menu</i>;
  }
}
